"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconViewList = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgWrapper = require("b2b-components/core/components/Icon/Icon/SvgWrapper");
const IconViewList = props => /*#__PURE__*/_react.default.createElement(_SvgWrapper.SvgWrapper, props, /*#__PURE__*/_react.default.createElement("path", {
  d: "M19.15 18.842V16.14H4.85v2.703a.3.3 0 0 0 .086.222.3.3 0 0 0 .221.086h13.684a.3.3 0 0 0 .222-.086.3.3 0 0 0 .086-.222Zm0-4.853V10.01H4.85v3.978h14.3Zm0-6.128V5.158a.3.3 0 0 0-.087-.222.3.3 0 0 0-.221-.086H5.156a.3.3 0 0 0-.221.086.3.3 0 0 0-.087.222V7.86h14.3ZM5.156 21.3a2.37 2.37 0 0 1-1.742-.716 2.371 2.371 0 0 1-.716-1.742V5.158c0-.684.239-1.265.716-1.742A2.37 2.37 0 0 1 5.157 2.7h13.684a2.37 2.37 0 0 1 1.742.716 2.37 2.37 0 0 1 .716 1.742v13.684a2.37 2.37 0 0 1-.716 1.742 2.37 2.37 0 0 1-1.741.716H5.156Z"
}));
exports.IconViewList = IconViewList;
//# sourceMappingURL=IconViewList.js.map